<template>
    <div class="position-box">
      <div class="head">
        <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
        <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
        <div class="title">Certification results</div>
      </div>
      <div class="cotainer">
        <div class="results-box">
          <img class="img" src="@/assets/yanzi/dagou.png" alt="">
          <!-- 失败 -->
          <img class="img2" src="@/assets/yanzi/dacha.png" style="display:none" alt="">
          <div class="t1">successful</div>
          <div class="t1 failed">Authentication failed</div>
          <div class="t2">Congratulations on your a ssets being certified</div>
          <div class="btn-sure">Confirm</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'results',
    data () {
        return {
          theme: false,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {

    },
    methods: {
        goBack(){
          this.$router.push('/verification')
        },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
     .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #f3f3f3;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .32rem;
        background: #f3f3f3;
        box-sizing: border-box;
        overflow-y: scroll;
        text-align: center;
    }
    .results-box{
      margin-top: 1.2rem;
      padding: .92rem .54rem 3.4rem;
      border-radius: .2rem;
      background: #fff;
    }
    .results-box .img{
      width: 4.62rem;
    }
    .results-box .img2{
      width: 2.78rem;
    }
    .results-box .t1{
      padding: .2rem 0 .7rem;
      color: #1cbc60;
      font-size: .62rem;
    }
    .results-box .t1.failed{
      color: #d81e06;
    }
    .results-box .t2{
      color: #000;
      font-size: .58rem;
    }
    .btn-sure{
      width: 9.06rem;
      height: 1.32rem;
      margin: 2.9rem auto 0;
      color: #fff;
      font-size: .56rem;
      line-height: 1.32rem;
      background: #4458ed;
      border-radius: 0.66rem;
      border: 1px solid #e4e4e4;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/capital/results.vue